import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import BillingAndEnrollmentProps from './types';
import {
  BillingAndEnrollmentSx,
  HeaderTypographySx,
  FieldTypographySx,
} from './styles';
import Stack from '@mui/material/Stack';
import { formatBillingAddress } from './utils';

const BillingAndEnrollment = ({ organization }: BillingAndEnrollmentProps) => {
  return (
    <Container sx={BillingAndEnrollmentSx}>
      <Stack direction="column" gap="12px">
        <Typography variant="h6">Billing Information</Typography>
        <Typography variant="body1" sx={FieldTypographySx}>
          {formatBillingAddress(organization?.primaryBillingAddress)}
        </Typography>
        <Typography sx={HeaderTypographySx}>INTERNAL NOTES</Typography>
        <Typography variant="body1" sx={FieldTypographySx}>
          {organization?.internalNotes}
        </Typography>
      </Stack>
      <Stack direction="column" gap="12px">
        <Typography variant="h6">Enrollment Information</Typography>
        <Typography sx={HeaderTypographySx}>APPLE BUSINESS MANAGER</Typography>
        <Typography variant="body1" sx={FieldTypographySx}>
          {organization?.appleDepNumber}
        </Typography>
        <Typography sx={HeaderTypographySx}>WINDOWS AUTOPILOT</Typography>
        <Typography variant="body1" sx={FieldTypographySx}>
          {organization?.windowsAutopilot}
        </Typography>
        <Typography sx={HeaderTypographySx}>ADDITIONAL ENROLLMENT</Typography>
        <Typography variant="body1" sx={FieldTypographySx}>
          {organization?.additionalEnrollment}
        </Typography>
      </Stack>
    </Container>
  );
};

export default BillingAndEnrollment;
